import { memo, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { formatDate } from "../../../common";
import { GENDERS_FORMAT, listStatus, STATUS_USER_COMMON, StudentType } from "../../../constant";
import { useGetAllBranch } from "../../../hooks/query/useGetAllBranch";
import { useGetAllUser } from "../../../hooks/query/useGetAllUser";
import { useUpdateStudent } from "../../../hooks/query/useUpdateStudent";
import { useDebounce } from "../../../hooks/useDebounce";
import InputSelect from "../../InputSelect";
import InputText from "../../InputText";

function Student() {
    const [name, setName] = useState("");
    const nameDebounce = useDebounce(name, 500);
    const [branch, setBranch] = useState("");
    const [status, setStatus] = useState("");
    const [listBranch, setListBranch] = useState([]);
    const [editingId, setEditingId] = useState<number | null>(null);
    const [editForm, setEditForm] = useState<any>({});
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { data } = useGetAllBranch(1, 10);
    const params = {
        ...(name && { name: nameDebounce }),
        ...(branch && { branch }),
        ...(status && { status }),
        userType: "student",
    };
    const { data: listStudent } = useGetAllUser(params);
    const { mutate: updateStudent, isPending } = useUpdateStudent();

    const formatData = (data: any) => {
        return data?.slice()
            .sort((a: any, b: any) => a.id - b.id)
            .map((branch: any) => {
                return {
                    value: branch.code,
                    label: branch.name
                }
            })
    }

    const genderOptions = [
        { value: "male", label: "Nam" },
        { value: "female", label: "Nữ" },
        { value: "other", label: "Khác" }
    ];

    const handleRowClick = (student: StudentType) => {
        setEditingId(student.id);
        setEditForm({
            fullName: student.fullName,
            gender: student.gender,
            dateOfBirth: student.dateOfBirth?.split('T')[0] || "",
            email: student.email || "",
            phoneNumber: student.phoneNumber || "",
            address: student.address || "",
            status: student.status,
            schoolGrade: student.student?.schoolGrade || ""
        });
        setIsModalOpen(true);
    };

    const handleInputChange = (field: string, value: any) => {
        setEditForm((prev: any) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleUpdateStudent = () => {
        if (!editingId) return;

        updateStudent(
            {
                id: editingId,
                data: {
                    fullName: editForm.fullName,
                    gender: editForm.gender,
                    dateOfBirth: editForm.dateOfBirth,
                    email: editForm.email,
                    phoneNumber: editForm.phoneNumber,
                    address: editForm.address,
                    status: editForm.status,
                    schoolGrade: editForm.schoolGrade
                }
            },
            {
                onSuccess: () => {
                    toast.success("Cập nhật dữ liệu học sinh thành công!");
                    setIsModalOpen(false);
                    setEditingId(null);
                    setEditForm({});
                },
                onError: (error: any) => {
                    console.error("Error updating student:", error);
                    toast.error("Cập nhật dữ liệu học sinh thất bại!");
                }
            }
        );
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setEditingId(null);
        setEditForm({});
    };

    useEffect(() => {
        if (data?.data) {
            const result = formatData(data?.data.items);
            setListBranch(result)
        }
    }, [data])

    console.log("listStudent", listStudent);

    return (<div className="text-white p-[20px] pt-[10px] w-full h-screen">
        <h1 className="font-bold text-[30px] text-center">THÔNG TIN HỌC SINH</h1>
        <div className="mt-[40px]">
            <hr className="my-6" />
            <h2 className="font-bold text-[20px] text-center">Tìm kiếm thông tin học sinh</h2>
            <div className="w-[30%] mt-[20px]">
                <InputText value={name} onChange={(e) => setName(e.target.value)} label="Tên học sinh" placeholder="Nhập tên học sinh..." name="name" inputStyle="text-black" />
                <InputSelect onChange={(e) => setBranch(e.target.value)} value={branch} data={listBranch} name="branch" label="Tên chi nhánh" inputStyle="text-black" />
                <InputSelect onChange={(e) => setStatus(e.target.value)} value={status} data={listStatus} name="branch" label="Tình trạng hoạt động" inputStyle="text-black" />
            </div>
            <div className="mt-[20px]">
                <hr className="my-6" />
                <h2 className="font-bold text-[20px] text-center mb-[40px]">Danh sách học sinh</h2>
                {listStudent?.data?.length > 0 ? (
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-gray-800 border border-gray-700 rounded-lg">
                            <thead className="bg-gray-700">
                                <tr>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">ID</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Họ và tên</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Giới tính</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Ngày sinh</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Email</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Số điện thoại</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Địa chỉ</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Trạng thái</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Khối lớp</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listStudent?.data?.length > 0 && listStudent?.data?.map((student: StudentType, index: number) => (
                                    <tr
                                        key={student.id}
                                        onClick={() => handleRowClick(student)}
                                        className={`border-t border-gray-700 ${index % 2 === 0 ? 'bg-gray-800' : 'bg-gray-750'} hover:bg-gray-600 transition-colors cursor-pointer`}
                                    >
                                        <td className="px-4 py-3 text-sm">{student.id}</td>
                                        <td className="px-4 py-3 text-sm font-medium capitalize">{student.fullName}</td>
                                        <td className="px-4 py-3 text-sm capitalize">{GENDERS_FORMAT[student.gender]}</td>
                                        <td className="px-4 py-3 text-sm">{formatDate(student.dateOfBirth)}</td>
                                        <td className="px-4 py-3 text-sm">{student.email || "Chưa cập nhật"}</td>
                                        <td className="px-4 py-3 text-sm">{student.phoneNumber || "Chưa cập nhật"}</td>
                                        <td className="px-4 py-3 text-sm">{student.address || "Chưa cập nhật"}</td>
                                        <td className="px-4 py-3 text-sm">
                                            <span className={`capitalize font-bold px-2 py-1 rounded-full text-xs ${student.status === 'active' ? 'bg-green-600' : student.status === 'pending' ? 'bg-yellow-400' : 'bg-red-600'}`}>
                                                {STATUS_USER_COMMON[student.status]}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3 text-sm">{student.student?.schoolGrade || "Chưa cập nhật"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="text-center py-10 text-gray-400">
                        <p>Không tìm thấy học sinh nào</p>
                    </div>
                )}
            </div>
        </div>

        {/* Modal chỉnh sửa */}
        {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-gray-800 rounded-lg p-6 w-[600px] max-h-[90vh] overflow-y-auto">
                    <h2 className="text-2xl font-bold mb-4 text-center">Chỉnh sửa thông tin học sinh</h2>

                    <div className="space-y-4">
                        <InputText
                            label="Họ và tên"
                            value={editForm.fullName}
                            onChange={(e) => handleInputChange('fullName', e.target.value)}
                            name="fullName"
                            inputStyle="text-black"
                        />

                        <InputSelect
                            label="Giới tính"
                            value={editForm.gender}
                            onChange={(e) => handleInputChange('gender', e.target.value)}
                            data={genderOptions}
                            name="gender"
                            inputStyle="text-black"
                        />

                        <div>
                            <label className="block text-sm font-medium mb-2">Ngày sinh</label>
                            <input
                                type="date"
                                value={editForm.dateOfBirth}
                                onChange={(e) => handleInputChange('dateOfBirth', e.target.value)}
                                className="w-full px-3 py-2 rounded bg-white text-black"
                            />
                        </div>

                        <InputText
                            label="Email"
                            value={editForm.email}
                            onChange={(e) => handleInputChange('email', e.target.value)}
                            name="email"
                            inputStyle="text-black"
                        />

                        <InputText
                            label="Số điện thoại"
                            value={editForm.phoneNumber}
                            onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
                            name="phoneNumber"
                            inputStyle="text-black"
                        />

                        <InputText
                            label="Địa chỉ"
                            value={editForm.address}
                            onChange={(e) => handleInputChange('address', e.target.value)}
                            name="address"
                            inputStyle="text-black"
                        />

                        <InputSelect
                            label="Trạng thái"
                            value={editForm.status}
                            onChange={(e) => handleInputChange('status', e.target.value)}
                            data={listStatus}
                            name="status"
                            inputStyle="text-black"
                        />

                        <InputText
                            label="Khối lớp"
                            value={editForm.schoolGrade}
                            onChange={(e) => handleInputChange('schoolGrade', e.target.value)}
                            name="schoolGrade"
                            type="number"
                            inputStyle="text-black"
                        />
                    </div>

                    <div className="flex gap-4 mt-6">
                        <button
                            onClick={handleUpdateStudent}
                            disabled={isPending}
                            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition-colors disabled:bg-blue-400 disabled:cursor-not-allowed"
                        >
                            {isPending ? "Đang cập nhật..." : "Cập nhật"}
                        </button>
                        <button
                            onClick={handleCloseModal}
                            disabled={isPending}
                            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                        >
                            Hủy
                        </button>
                    </div>
                </div>
            </div>
        )}
    </div>);
}

export default memo(Student);